export default __webpack_public_path__ + "static/media/html.2e1e6fa9.PNG";